import { render, staticRenderFns } from "./refund_goods.vue?vue&type=template&id=7b08a2ac&scoped=true"
import script from "./refund_goods.vue?vue&type=script&lang=js"
export * from "./refund_goods.vue?vue&type=script&lang=js"
import style0 from "./refund_goods.vue?vue&type=style&index=0&id=7b08a2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b08a2ac",
  null
  
)

export default component.exports